<script>
import axios from '@/utils/axios';
import { Modal } from 'bootstrap';
import { useToast } from 'vue-toastification';
import { customerUtils } from '@/utils/customer';

export default {
  inject: ['setLoading'],
  data() {
    return {
      id: '',
      ids: [],
      toast: useToast(),
      currency: '',
      customer_id: '',
      notes: '',
      errors: {},
      app_currency: '',
      items: [],
      item: '',
      customers: [],
      customer: '',
      subscription_name: '',
      duration: 1,
      duration_types: ['days','months','years'],
      start_date: '',
      price: '',
      status: '',
      loading: false,
    };
  },

 watch: {
  item(newItem){
   if(newItem){
    this.price = newItem.price || '';
    this.subscription_name = newItem.name || '';
   }
  }
 },

 async mounted(){ 
  this.app_currency = await this.$appCurrency();
 },

 methods: { 
    
  async alItems(){
   try{
    const res = await axios.get('/items/services');
    this.items = res.data.data;
   }catch(error){
    this.toast.error(error.message);
   }
  },  

  async onSearch(search) {
   this.loading = true;
   this.customers = await customerUtils.onSearch(search);
   this.loading = false;
  },

  async getCustomerById(id) {
   this.customer = await customerUtils.getCustomerById(id);
  },

  async add(customer_id){
   this.alItems(); 
   await this.getCustomerById(customer_id);
  },

  async edit(row){
   this.id = row.id;  
   this.status = row.status;
   this.duration = row.duration;
   this.duration_type = row.duration_type;
   this.start_date = row.start_date;
   this.notes = row.notes;
   await this.alItems(); 
   this.item = this.items.find(i => i.id === row.item_id);
   await this.getCustomerById(row.customer_id);
   this.price = row.price;
   this.subscription_name = row.subscription_name;
  },
   
  async submitSubscription(){
   this.errors = {}; 
   this.setLoading(true);
    try{
     const payload = {
       id: this.id, 
       customer_id: this.customer?.id,
       item_id: this.item?.id,
       subscription_name: this.subscription_name,
       duration: this.duration,
       duration_type: this.duration_type,
       start_date: this.start_date,
       price: this.price,
       notes: this.notes
     };
       
      let response = [];
      if(this.id){
       response = await axios.put(`/subscriptions/${this.id}/update`, payload);
      }else{
       response = await axios.post(`/subscriptions/create`, payload); 
      }  
      
      this.toast.success(response.data.message);
      this.$emit('updated');
      this.closeModal('subscription_modal');
      this.resetForm();
     }catch(error){
      if(error?.type === 'validation'){
       this.errors = error.errors;
      }else{
       this.toast.error(error.message);
      }
     }finally{
      this.setLoading(false);
    }
  },

  closeModal(modalId) {
   const modalEl = document.getElementById(modalId);
   const modal = Modal.getInstance(modalEl);
   if (modal) modal.hide();
  },

  resetForm() {
   this.id = null;
   this.errors = {}; 
   this.customer = '';
   this.item = '';
   this.subscription_name = '';
   this.duration = 1;
   this.duration_type = 'months';
   this.start_date = '';
   this.price = '';
   this.notes = '';
  }

 }
};
</script>

<template>
<!-- SUBSCRIPTION MODAL -->
<div class="modal fade" id="subscription_modal">
<div class="modal-dialog modal-dialog-centered modal-lg w-100">
<div class="modal-content">
<div class="modal-header">
 <h4 class="modal-title">{{ id ? 'Edit' : 'Add' }} Subscription</h4>
  <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
  <i class="ti ti-x"></i>
  </button>
</div>

 <form @submit.prevent="submitSubscription">
  <div class="modal-body pb-0">
  <div class="row">
    
    <!-- Customer -->
    <div class="col-md-6">
    <label class="form-label">Customer <span class="text-danger">*</span></label>
    <vue-select :options="customers" label="name" v-model="customer" placeholder="Select Customer" :loading="loading" :filterable="false" @search="onSearch"/>
    <div v-if="errors.customer_id" class="text-danger small mt-1">{{ errors.customer_id[0] }}</div>
    </div>

    <!-- Item -->
    <div class="col-md-6">
    <label class="form-label">Service/Item <span class="text-danger">*</span></label>
    <vue-select :options="items" label="name" v-model="item" placeholder="Select Item" />
    <div v-if="errors.item_id" class="text-danger small mt-1">{{ errors.item_id[0] }}</div>
    </div>

    <!-- Subscription Name -->
    <div class="col-md-12 mt-2">
    <label class="form-label">Subscription Name <span class="text-danger">*</span></label>
    <input type="text" class="form-control" v-model="subscription_name" placeholder="Enter subscription name" />
    <div v-if="errors.subscription_name" class="text-danger small mt-1">{{ errors.subscription_name[0] }}</div>
    </div>

    <!-- Duration -->
    <div class="col-md-4 mt-2">
    <label class="form-label">Duration <span class="text-danger">*</span></label>
    <input type="number" class="form-control" v-model="duration" min="1" />
    <div v-if="errors.duration" class="text-danger small mt-1">{{ errors.duration[0] }}</div>
    </div>

    <!-- Duration Type -->
    <div class="col-md-4 mt-2">
    <label class="form-label">Duration Type <span class="text-danger">*</span></label>
    <vue-select v-model="duration_type" :options="duration_types" placeholder="Select Type" />
    <div v-if="errors.duration_type" class="text-danger small mt-1">{{ errors.duration_type[0] }}</div>
    </div>

    <!-- Start Date -->
    <div class="col-md-4 mt-2">
    <label class="form-label">Start Date <span class="text-danger">*</span></label>
    <input type="date" class="form-control" v-model="start_date" />
    <div v-if="errors.start_date" class="text-danger small mt-1">{{ errors.start_date[0] }}</div>
    </div>

    <div class="col-md-6 mt-2">
    <label class="form-label">Price <span class="text-danger">*</span></label>
    <input type="number" step="0.01" class="form-control" v-model="price" placeholder="0.00" />
    <div v-if="errors.price" class="text-danger small mt-1">{{ errors.price[0] }}</div>
    </div>

    <!-- Notes -->
    <div class="col-md-12 mt-2">
    <label class="form-label">Notes</label>
    <textarea class="form-control" v-model="notes" rows="3" placeholder="Additional notes..."></textarea>
    <div v-if="errors.notes" class="text-danger small mt-1">{{ errors.notes[0] }}</div>
    </div>

    </div>
    </div> 
    
    <div class="modal-footer">
    <button type="button" class="btn btn-secondary me-2" data-bs-dismiss="modal">Cancel</button>
    <button type="submit" class="btn btn-primary">{{ id ? 'Update' : 'Save' }} Subscription</button>
    </div>
  </form>

  </div>
 </div>
</div>

<!-- View Details -->
<div class="modal fade" id="subscription_view_modal">
<div class="modal-dialog modal-dialog-centered">
<div class="modal-content">
<div class="modal-header bg-dark">
<h4 class="modal-title text-white">Subscription Details</h4>
<button type="button" class="btn-close custom-btn-close bg-transparent fs-16 text-white position-static" data-bs-dismiss="modal" aria-label="Close"><i class="ti ti-x"></i></button>
</div>
<div class="modal-body">
<h5 class="mb-2">
  <span :class="['badge', 'badge-pill', 'text-capitalize', {
                 'bg-success': status === 'active',
                 'bg-secondary': status === 'paused',
                 'bg-primary': status === 'completed',
                 'bg-danger': status === 'cancelled'
                }]">{{ status }}</span>
</h5>
<div class="border rounded mb-3 p-2">
<div class="row row-gap-3">
 <div class="col-md-4">
 <div class="text-center">
   <span class="d-block mb-1 fw-bold">Name</span>
   <p class="text-dark fw-normal">{{ subscription_name }}</p>
 </div>
 </div>
 <div class="col-md-5">
 <div class="text-center">
    <span class="d-block mb-1 fw-bold">Duration</span>
    <p class="text-dark fw-normal">{{ duration }} {{ duration_type }}</p>
 </div>
 </div>
 <div class="col-md-3">
 <div class="text-center">
 <span class="d-block mb-1 fw-bold">Price</span>
  <span class="badge bg-secondary d-inline-flex align-items-center">{{app_currency.code}} {{ price }}</span>
 </div>
 </div>
</div>
</div>

 <div class="mb-3" v-if="notes">
 <h5 class="mb-2">Notes</h5>
 <p v-html="notes" style="max-height: 150px; overflow-y: auto;"></p>
 </div>

 <div class="schedule-timeline">

  <div class="d-flex align-items-center">
  <div class="d-flex align-items-center active-time"><span class="timeline-date text-success">{{ $formatDate(start_date, 'DD-MM-YYYY') }}</span><span class="timeline-border d-flex align-items-center justify-content-center bg-white"><i class="ti ti-point-filled text-gray-2 fs-18"></i></span></div>
  <div class="flex-fill ps-3 pb-4 timeline-hrline">
   <div class="mt-4">
    <p class="fw-medium text-gray-9 mb-1">Start Date</p>
   </div>
  </div>
  </div>

  <div class="d-flex align-items-center">
  <div class="d-flex align-items-center active-time"><span class="timeline-date text-danger">{{ $formatDate(end_date, 'DD-MM-YYYY') }}</span><span class="timeline-border d-flex align-items-center justify-content-center bg-white"><i class="ti ti-point-filled text-gray-2 fs-18"></i></span></div>
  <div class="flex-fill ps-3 pb-4 timeline-hrline">
   <div class="mt-4">
    <p class="fw-medium text-gray-9 mb-1">End Date</p>
   </div>
  </div>
  </div>
   
  <div class="d-flex align-items-center">
    <div class="flex-fill ps-3 pb-0 timeline-hrline"></div>
  </div>
</div>

</div>
</div>
</div>
</div>
<!-- /View Details -->

</template>